module.exports = __webpack_public_path__ + "img/credenza.bd6256d.svg";